/*
 * @Author: Dong
 * @Date: 2022-04-11 16:19:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-25 15:31:08
 */
import { defineMessages } from 'react-intl';

const object: { [key: string]: string } = {
  businessDataSyncBack: '业务数据备份还原',
  sequenceDataSync: '时序数据备份',
  logRecord: '日志记录',
  noBackupData: '您好，您还没有备份',
  backup: '备份',
  back: '还原',
  set: '设置',
  autoBackup: '自动备份',
  nextSyncTime: '下次备份时间',
  startTime: '开始时间',
  syncTimes: '备份频率',
  saveCount: '保留份数',
  syncTimesUnit: '天/次',
  saveCountUnit: '份',
  lastSyncTime: '最后同步时间',
  sequenceSyncBackup: '时序数据增量备份',
  sequenceModalTitle: '请配置Rsync服务器',
  confirmCloseSequenceCheckedTip: '该操作会停止备份同步,且下次同步时可能需要重新全量同步，确认关闭？',
  endTime: '结束时间',
  type: '类型',
  status: '状态',
  content: '内容',
  operateUser: '操作员',
  success: '成功',
  failure: '失败',
  businessBackup: '业务数据备份',
  businessBack: '业务数据还原',
  sequenceBackup: '时序数据备份',
  lastBackupTime: '最近一次备份时间',
  filePath: '文件位置',
  fileSize: '已备份文件大小',
  diskFreeSpace: '磁盘可用空间',
  successCopy: '已复制文件路径',
  doingBackup: '正在备份',
  doingBack: '正在还原',
  startBackupTime: '开始备份时间',
  startBackTime: '开始还原时间',
  detail: '详情',
  logDownload: '日志下载',
  modalBackupTitle: '请描述备份文件',
  modalBackTitle: '请选择备份文件',
  modalBackupSetTitle: '备份设置',
  savePath: '储存路径',
  desc: '描述',
  serial: '序号',
  file: '文件',
  version: '版本',
  freeSpace: '当前可用空间',
  ipRequired: '请输入IP',
  port: '端口',
  portRequired: '请输入端口',
  userName: '用户名',
  userNameRequired: '请输入用户名',
  password: '密码',
  passwordRequired: '请输入密码',
  savePathRequired: '请输入储存路径',
  startTimeRequired: '请输入开始时间',
  saveCountRule: '请输入1至7的整数',
  syncTimesRule: '请输入大于等于1的整数',
  backupFilePath: '备份文件所在位置',
  syncBackup: '同步备份',
  annex: '业务附件备份',
  increment: '业务附件增量备份',
  autoBackupFail: '自动备份失败',
  setAutoBackupSuccess: '自动备份设置成功',
  setAutoBackupFail: '自动备份设置失败',
  dateError: '日期不能早于当前时间',

  minio: '业务附件备份',
  minioIntroduce: '业务附件备份主要包含supOS中的低代码APP的静态资源文件、APP上传的附件类文件。',
  confirmMinioBackupTip: '请确认开始业务附件备份？',
  confirmSpaceTip: '/backup磁盘空间不足（还需{size}GB）， 无法完全备份当前minio数据，请增加磁盘空间。',
  confirmColse: '请确认关闭？',
  backupFailed: '备份失败',
  recoverFailed: '恢复失败',
  gotIt: '知道了',
  ipError: '请输入正确的IP',
  portError: '请输入正确的端口',
  confirmBack: '确定把业务数据还原到“{type}”?',
  minioBackup: '业务附件备份',
  system: '系统',
  business:
    '业务数据包含supOS平台的配置数据和运行数据，如采集器节点管理、对象建模、用户、人员、组织机构、菜单权限、系统消息、国际化、业务流程、系统配置等数据。',
  sequentialIntroduce:
    '时序数据包含从采集器、网关接入数据的历史数据及平台上自定义的BOOLEAN、STRING、INTEGER、LONG、DOUBLE、DECIMAL类型的对象属性的历史数据',
  runned: '运行时长',
  logTime: '时间',
  reset: '重置',
  recordTime: '记录时间',
  all: '全部',
  placeholderSaveCountUnit: '请填写保留份数',
  placeholdersSyncTimesUnit: '请填写间隔天数',
  searchTip: '输入日志内容搜索',
  rsyncConfirm: '开始备份后，服务器上存储路径下的数据会被覆盖，请确认数据已经备份好或者允许覆盖。',
};
export default defineMessages(object);
